import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Crown } from 'lucide-react';
import CrazyVipExperience from './CrazyVipExperience';

const ROWS = [
    { name: 'ZOMERGOESTING', desc: 'VIP-beleving inbegrepen', accent: 'bg-[var(--yellow)]' },
    { name: 'ZOMERVIBES', desc: 'Uitgebreide VIP-beleving', accent: 'bg-[var(--pink)]' },
    { name: 'ZOMERBOOST', desc: 'Ruime VIP-beleving', accent: 'bg-[var(--mint)]' },
    { name: 'ZOMERKICK', desc: 'Premium VIP-beleving', accent: 'bg-[var(--lilac)]' },
];

export const CrazyVip = () => {
    return (
        <section
            id="crazy-vip"
            data-testid="crazy-vip-section"
            className="relative py-16 sm:py-20 bg-cream"
        >
            <div className="mx-auto max-w-5xl px-5 sm:px-8">
                <div className="bg-[#ecdef0]/40 border-2 border-[var(--green)] rounded-[28px] p-6 sm:p-10 shadow-[0_6px_0_var(--green-dark)]">
                    <div className="flex items-center gap-3 justify-center mb-4">
                        <Crown className="text-[var(--green-dark)]" size={28} />
                        <h2
                            data-testid="crazy-vip-title"
                            className="zz-outline-title font-display"
                            style={{ fontSize: 'clamp(1.75rem, 4.5vw, 3rem)' }}
                        >
                            CRAZY VIP
                        </h2>
                    </div>

                    <p className="text-center text-base sm:text-lg text-[var(--green-dark)] max-w-2xl mx-auto leading-relaxed">
                        Wil je je relaties of medewerkers iets onvergetelijks bezorgen tijdens Zotte Zomer? Dan is onze
                        Crazy VIP-beleving een perfecte gelegenheid om hen extra in de watten te leggen, op een unieke
                        festivalavond.
                    </p>

                    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                        {ROWS.map((r) => (
                            <div
                                key={r.name}
                                data-testid={`crazy-vip-row-${r.name}`}
                                className={`${r.accent} border-2 border-[var(--green-dark)] rounded-2xl px-5 py-4 flex items-center justify-between gap-4`}
                            >
                                <span className="font-display text-sm sm:text-base text-[var(--green-dark)]">
                                    {r.name}
                                </span>
                                <span className="text-sm text-[#006b44]/90 text-right">
                                    {r.desc}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className="mt-7 text-center">
                        <Link
                            to="/#brochure"
                            data-testid="crazy-vip-cta"
                            className="inline-flex items-center gap-1.5 text-sm font-display text-[var(--green)] hover:text-[var(--green-dark)] transition-colors"
                        >
                            Meer details? Vraag de partnerbrochure aan <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
                <CrazyVipExperience />
            </div>
        </section>
    );
};

export default CrazyVip;
